<template>
  <div class="reporting-section-bordered h-100 px-0 mx-0 d-flex flex-column">
    <div class="reporting-sections-wrapper">
      <div class="reporting-section box-shadow-top-left">
        <div class="button-wrapper ml-3 mt-2">
          <v-btn
            :disabled="!canViewStatsReport"
            variant="flat"
            primary
            :to="goToDetailedView('stats')"
          >
            {{ tkey('sections.view') }}
          </v-btn>
        </div>
        <ReportingPageStats short-view class="flex-grow-1 shortview-report" />
      </div>

      <div class="reporting-section box-shadow-top-right">
        <div class="button-wrapper ml-3 mt-2">
          <v-btn
            variant="flat"
            primary
            :disabled="!canViewRelativeShareReport"
            :to="goToDetailedView('relative-share')"
          >
            {{ tkey('sections.view') }}
          </v-btn>
        </div>
        <ReportingPageRelativeShare short-view class="flex-grow-1 shortview-report" />
      </div>

      <div class="reporting-section box-shadow-bottom-left">
        <div class="button-wrapper ml-3 mt-2">
          <v-btn
            variant="flat"
            primary
            :disabled="!canViewPriceLadderReport"
            :to="goToDetailedView('price-ladder')"
          >
            {{ tkey('sections.view') }}
          </v-btn>
        </div>
        <ReportingPagePriceLadder short-view class="flex-grow-1 shortview-report" />
      </div>

      <div class="reporting-section box-shadow-bottom-right">
        <div class="button-wrapper ml-3 mt-2">
          <v-btn
            variant="flat"
            primary
            :disabled="!canViewComparisonWaterfallReport"
            :to="goToDetailedView('comparison-waterfall')"
          >
            {{ tkey('sections.view') }}
          </v-btn>
        </div>
        <ReportingPageComparisonWaterfall short-view class="flex-grow-1 shortview-report" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useInternationalization } from '@/composables/use-internationalization';
import { usePermission } from '@/composables/use-permission';

const route = useRoute();
const { tkey } = useInternationalization('reportingPage');
const {
  canViewStatsReport,
  canViewRelativeShareReport,
  canViewPriceLadderReport,
  canViewComparisonWaterfallReport,
} = usePermission();

const goToDetailedView = page => {
  return {
    path: `/reporting-main/${page}`,
    query: route.query,
  };
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.reporting-sections-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  margin-bottom: 20px;
  background-color: $assortment-background;
  height: 100%;
}

.reporting-section {
  background-color: $reporting-section-bg-color;
  display: flex;
  flex-direction: column;
  width: 100%;
  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
  }

  .shortview-report {
    margin-top: -29px;
  }

  button {
    width: 60px;
    margin-top: 10px;
    margin-right: 10px;
  }
}
.font-size-medium {
  font-size: medium;
}
:deep(.section .subtitle) {
  font-weight: bold;
  font-size: 1.4rem;
}
</style>
